import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FaMapMarkerAlt, FaUserTie } from "react-icons/fa";

export default function ContactUs() {
  return (
    <section className="contact-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle">
            We’re here to support your global logistics needs
          </p>
        </div>

        <Row className="g-4 align-items-stretch">
          <Col lg={5}>
            <Card className="contact-card h-100">
              <Card.Body>
                <h4 className="mb-4">Get in Touch</h4>

                <div className="contact-item">
                  <FaUserTie />
                  <div>
                    <strong>Anand Rao</strong>
                    <p>+91 63573 10056</p>
                  </div>
                </div>

                <div className="contact-item">
                  <FaUserTie />
                  <div>
                    <strong>Rahul Rathore</strong>
                    <p>+91 70434 44944</p>
                  </div>
                </div>

                <div className="contact-item">
                  <FaMapMarkerAlt />
                  <div>
                    <strong>Office Address</strong>
                    <p>
                      Office No. B-145, NU-4, Sapna Nagar,<br />
                      Gandhidham, Kutch – 370201,<br />
                      Gujarat, India
                    </p>
                  </div>
                </div>

                <Button className="primary-btn mt-3" href="mailto:rrshiplog.imp@gmail.com">
                  Enquire Now
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={7}>
            <div className="map-wrapper">
              <iframe
                title="RR Shipping & Logistics Location"
                src="https://www.google.com/maps?q=Sapna%20Nagar%20Gandhidham%20Kutch%20370201&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
